// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const profile = {
  profile_section: {
    utilization_description:
      '我们将利用这些信息进一步完善对您明年可能面临的医疗费用的预测。虽然一个人的医疗需求通常每年都会有所变化,但了解您过去的医疗使用情况有助于我们提供更个性化的建议。',
    member_card_data: {
      person: {
        spouse: '配偶/伴侣',
        dependent: '受抚养人',
        policyholder: '您',
        policyholder_enter: '添加您的信息',
      },
      ageTitle: '年龄',
      sexTitle: '性别',
      zipTitle: '邮政编码',
      sexOptions: {
        F: '女',
        M: '男',
      },
      stateTitle: '州',
      tobaccoUse: '使用烟草',
      tobaccoInfo: '您的某些符合条件的福利可能需要支付烟草附加费。',
    },
    navigation: {
      risk: '风险',
      income: '收入',
      member: '您和家人',
      pregnancy: '怀孕',
      medication: '处方药',
      pillContent: {
        risk: ['低', '中', '高'],
        pregnant: '宝宝',
      },
      utilization: '使用率',
      capacityToPay: '支付能力',
    },
    pregnancy_heading: '您的家庭是否计划在未来一年内怀孕?',
    button_text: {
      risk: '继续',
      income: '继续',
      member: {
        myself: '我只为自己投保',
        meAndChild: '我为自己和我的孩子投保',
        meAndOthers: '我为自己和其他{x}人投保',
        meAndSpouse: '我为自己和我的配偶/伴侣投保',
        meAndOthersMobile: '我为{x}人投保',
      },
      capacity: '继续',
      pregnancy: {
        N: '否',
        Y: '是',
      },
      scroll_up: '第{x}个问题有错误',
      memberCard: '保存',
      scroll_down: '向下滚动',
      utilization: '显示我的结果',
      close_button: '关闭',
      prescriptions: {
        soloOne: '我服用1种处方药',
        soloMany: '我服用{x}种处方药',
        soloNone: '我不服用处方药',
        familyOne: '我的家人服用1种处方药',
        familyMany: '我的家人服用{x}种处方药',
        familyNone: '我的家人不服用处方药',
      },
      people_like_you: '继续',
    },
    prescriptions_heading: '您或您的家人服用哪些处方药?',
    claims: {
      contentful_name: '[DEFAULT] Claims Card',
      name: '当前医疗支出',
      tooltips: {
        name: {
          text: '此信息在提交后不会被保存。通过分享此信息,您允许ALEX参考您的整体医疗支出,为您提供更个性化的计划比较,并帮助您估算未来的医疗需求和费用偏好。ALEX不会参考您的任何个人理赔记录。',
          title: '',
          underline: '',
        },
        memberId: {
          text: '有时称为保单号或投保人ID,您通常可以在保险卡上找到此信息。请确保完全按照卡上所写的内容输入您的ID,包括字母和空格。',
          title: '',
          underline: '',
        },
      },
      member_id_description:
        '如果您手头有健康保险会员ID,我们可以查询您今年当前的医疗支出,以便您在比较计划时使用这些信息。',
      start_button: '让我们开始吧',
      skip_button: '跳过此项',
      edit_button: '编辑',
      submit_button: '查看我的消费',
      first_name: '您的法定名字',
      last_name: '您的法定姓氏',
      date_of_birth: '您的出生日期',
      date_of_birth_placeholder: 'MM/DD/YYYY',
      insurance_carrier: '保险承运人',
      insurance_carrier_no_results: '抱歉,ALEX无法查询此承运商的索赔信息。选择"跳过此项"以继续下一部分。',
      member_id: '会员ID',
      policyholder_question: '您是投保人吗?',
      policyholder_question_yes: '是的,这是我的计划',
      policyholder_question_no: '不,我在别人的套餐里',
      search_placeholder: '搜索承运商',
      submitted_message: '谢谢!请继续填写您的信息,我们稍后会审核您的数据。',
      success_message: '成功!继续查看您的消费信息。',
      error_message: '出现错误,请检查您的信息后重试。',
      claims_error_message: {
        timeout: 'ALEX 遇到错误。请稍后几',
      },
    },
    member_description:
      'ALEX利用这些信息来确定您可以选择的健康计划和保费,并开始了解您的每个健康保险计划将花费多少。',
    contentful_name: 'Profile Section (DEFAULT DO NOT CHANGE)',
    page_header: {
      text: '完善您的个人资料',
      subtext: '回答几个简单的问题,找到最适合您的福利。',
      text_return_user: '更新您的个人资料',
      subtext_integrated:
        '回答几个简单的问题,找到最适合您的福利。您的部分信息可能已使用雇主提供的数据预先填写。',
      subtext_return_user: '查看您的答案并进行更新,以找到最适合您的福利。',
    },
    tax_heading: '以下问题帮助我们计算与健康保险相关的税收优惠。',
    profile_complete_body: '确保您的答案准确无误，以便获得最佳推荐！返回此页面进行任何个人资料更新。',
    questions_text: {
      questionOne: {
        title: '假设您在未来一年需要昂贵医疗护理的可能性很低。您会选择以下哪种计划?',
        optionOne: {
          footer: '如果我需要昂贵的意外医疗护理,自付费用会更少。',
          heading: '每月为我的健康保险支付更多费用。',
        },
        optionTwo: {
          footer: '如果我需要昂贵的意外医疗护理,自付费用会更多。',
          heading: '每月为我的健康保险支付更少费用。',
        },
      },
      questionTwo: {
        title: '现在,如果您受伤并需要昂贵医疗护理的可能性增加到中等程度。您会选择以下哪种计划?',
        optionOne: {
          footer: '如果我需要昂贵的意外医疗护理,自付费用会更少。',
          heading: '每月为我的健康保险支付更多费用。',
        },
        optionTwo: {
          footer: '如果我需要昂贵的意外医疗护理,自付费用会更多。',
          heading: '每月为我的健康保险支付更少费用。',
        },
      },
    },
    accessibility: {
      instructions: '看起来您正在使用屏幕阅读器。当您回答问题时,更多内容将会显示。',
      unlocked_section: '已解锁 {x} 部分',
    },
    income_heading: '您家庭的总收入是多少?',
    prescriptions_headings: {
      self: '您定期服用哪些处方药?',
      family: '您的家人定期服用哪些处方药?',
      prescription_warning_text: '已添加 {x} 种处方药。请确保在继续之前添加所有处方药。',
    },
    tax_questions_text: {
      filingStatus: {
        title: '您的报税身份是什么?',
        options: {
          single: '单身',
          default: '选择报税身份',
          married: '已婚',
          headOfHousehold: '户主',
          marriedFilingSeparate: '已婚单独报税',
        },
      },
      spouseIncome: {
        title: '您配偶的税前年收入是多少?',
      },
      policyholderIncome: {
        title: '您的税前年收入是多少?(可以估算)',
      },
    },
    prescriptions_description:
      '当您告诉我们您日常服用的处方药时,我们能够利用这些信息提供更个性化的建议,这些建议会考虑到服用类似处方药人群的费用和风险。',
    cost_thresholds: {
      lt_500: '低于500美元',
      gt_6000: '6,000美元或以上',
      '500_1000': '500美元 - 999美元',
      '1000_2000': '1,000美元 - 1,999美元',
      '2000_3000': '2,000美元 - 2,999美元',
      '3000_4000': '3,000美元 - 3,999美元',
      '4000_6000': '4,000美元 - 5,999美元',
    },
    card_names: {
      risk: '风险承受能力',
      util: '利用率',
      income: '收入',
      capacity: '支付能力',
      location: '居住地',
      household: '家庭',
      pregnancy: '怀孕',
      enrollment: '注册',
      incentives: '激励措施',
      eligibility: '资格',
      utilization: '利用率',
      prescription: '处方',
    },
    prescriptions_illustration:
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/medication.svg',
    income: {
      contentful_name: '[DEFAULT] Income Card',
      name: '收入',
      tax_inputs_header: '接下来的问题将帮助ALEX计算与健康保险相关的税收优惠。',
      tooltips: {
        name: {
          text: '您的部分福利享有税收优惠。ALEX 使用您的收入来计算您可以节省多少税款。',
          title: '收入',
          underline: '收入',
        },
      },
      income_header: '您家庭的总收入是多少?',
      income_header_policyholder: '您的税前年收入是多少?(可以估算)',
      income_placeholder: '50,000',
      income_header_spouse: '您配偶的税前年收入是多少?',
      income_placeholder_spouse: '50,000',
      filing_status_header: '您的报税身份是什么?',
      filing_status_options: {
        default: '选择报税身份',
        options: ['单身', '已婚', '已婚单独报税', '户主'],
      },
      skip_income_button: '不愿透露',
    },
    risk_heading: '请告诉我们在以下情况中您更倾向于哪种类型的健康保险计划。',
    risk_aversion_info: {
      low: {
        text: '看起来您的风险规避程度较低。这意味着如果能为您提供最佳的省钱机会,您愿意承担更多风险。',
        header: '低风险规避',
      },
      high: {
        text: '看起来您的风险规避程度较高。这意味着您愿意为提供更多保障的计划支付更多费用。',
        header: '高风险规避',
      },
      medium: {
        text: '看起来您的风险规避程度为中等。这意味着您正在寻求风险保护与节省费用之间的平衡。',
        header: '中等风险规避',
      },
    },
    drug_search_text: {
      isLoading: '加载中...',
      mobileAdd: '+ 添加处方',
      placeholder: '搜索以添加处方...',
      noResultsFound: '未找到结果。',
      noPrescriptions: '未添加处方。',
    },
    eligibility: {
      contentful_name: '[DEFAULT] Eligibility Card',
      name: '资格条件',
      is_full_time_or_part_time: '您是全职员工还是兼职员工?',
      annual_policyholder_salary: '您的员工工资是多少?',
      occupation: '以下哪项最能描述您?',
      tooltips: {
        name: {
          text: 'ALEX 使用这些问题来确定您有资格参加哪些计划。',
          title: '资格',
          underline: '资格',
        },
      },
      part_time_ineligible_disclaimer: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
    },
    risk_description: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                '我们将使用您的回答来了解您的风险规避程度。风险规避描述了您面对风险时的舒适程度,我们在评估哪些福利最适合您时会考虑这些偏好。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    utilization_heading: '现在我们将询问您一些关于过去12个月医疗保健使用情况的问题。',
    income_illustration:
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/income-illustration.svg',
    location_heading: '你住在哪里?',
    capacity_description:
      '我们将使用这些信息来调整您的计划推荐,根据每个计划可能让您面临无法承担的医疗账单的可能性进行调整。',
    capacity_to_pay: {
      contentful_name: '[DEFAULT] Capacity to Pay Card',
      name: '经济实惠',
      header: '如果您在保险计划年度初期需要接受意外的医疗护理,您能承受的最大账单金额是多少?',
      button_options: {
        no: '否',
        yes: '是',
        lt_500: '少于$500',
        gt_6000: '$6,000或以上',
        '500_1000': '$500 - $999',
        '1000_2000': '$1,000 - $1,999',
        '2000_3000': '$2,000 - $2,999',
        '3000_4000': '$3,000 - $3,999',
        '4000_6000': '$4,000 - $5,999',
      },
      tooltips: {
        name: {
          text: 'ALEX 使用这些信息来调整您的计划推荐,依据是每个计划让您面临无法承担的医疗账单的可能性。',
          title: '可负担性',
          underline: '可负担性',
        },
      },
      hsa_header: '当前储蓄',
      hsa_subheader: '您是否在健康储蓄账户(HSA)中有资金,并计划在下一个计划年度用于医疗费用?',
      hsa_amount_question: '您愿意将多少HSA账户资金用于支付今年的费用?',
      hsa_tooltip: {
        name: {
          text: 'ALEX可以展示您现有的HSA储蓄如何应用于今年的费用。',
          title: '当前储蓄',
          underline: '当前储蓄',
        },
      },
    },
    risk: {
      contentful_name: '[Default] Risk Card',
      name: '保障偏好设置',
      deductible_usage: {
        contentful_name: '[Profile] [RiskCard] Deductible Usage',
        header:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您已支付',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '**{deductibleSpent}**',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '，免赔额为',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '**{deductibleTotal}**',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value:
                    ' 一般来说，较低的免赔额意味着您为保险支付更多费用，但在需要医疗服务时支付较少;而较高的免赔额意味着您为保险支付较少费用,但在需要医疗服务时支付更多。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'BellRinging',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      },
      deductible_usage_no_usage: {
        contentful_name: '[Profile] [RiskCard] Deductible Usage - No Usage',
        header:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您还没有为您的',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '**{deductibleTotal}**',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '免赔额支付任何费用。',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value:
                    ' 一般来说,较低的免赔额意味着您为保险支付更多费用,但在需要医疗服务时支付较少;而较高的免赔额意味着您为保险支付较少费用,但在需要医疗服务时支付更多。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'BellRinging',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      deductible_usage_loading_message: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'Loading results...',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      deductible_usage_error_message: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '我们无法获取您的免赔额信息。',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      tooltips: {
        name: {
          text: '这些问题帮助ALEX根据最适合您需求的计划设计类型,为您提供个性化推荐。',
          title: '保障偏好',
        },
      },
      header_question_a: '假设您在未来一年需要昂贵医疗护理的可能性很低。您会选择以下哪种计划?',
      header_question_b: '现在,如果您受伤并需要昂贵医疗护理的可能性增加到中等程度,您会选择以下哪个计划?',
      option_one_header: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '每月为我的健康保险支付更多费用。',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      option_one_text: '如果我需要昂贵的意外医疗护理,自付费用会更少。',
      option_two_header: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '每月为我的健康保险支付更少费用。',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      option_two_text: '如果我需要昂贵的意外医疗护理,则自付更多费用。',
      options: {
        optionOne: {
          text: 'options.optionOne.text',
          header: 'options.optionOne.header',
        },
        optionTwo: {
          text: 'options.optionTwo.text',
          header: 'options.optionTwo.header',
        },
      },
      risk_aversion_info: {
        low: {
          text: '看起来您的风险规避程度较低。这意味着如果能为您提供最佳的省钱机会,您愿意承担更多风险。',
          header: '低风险规避',
        },
        high: {
          text: '看起来您的风险规避程度较高。这意味着您愿意为提供更多保障的计划支付更多费用。',
          header: '高风险规避',
        },
        medium: {
          text: '看起来您的风险规避程度为中等。这意味着您在寻求风险保护和节省费用之间的平衡。',
          header: '中等风险规避',
        },
      },
    },
    individual_only: '注意：根据您对资格问题的回答,您可选择的计划不涵盖任何受抚养人。',
    profile_complete_header: '个人资料已完成!',
    enrollment: {
      contentful_name: '[DEFAULT] Enrollment Card',
      name: '注册',
      enrollment_reason_question: '哪个选项最符合您的情况?',
      enrollment_reason_open_enrollment: '我来办理开放注册。',
      enrollment_reason_new_hire: '我是新员工。',
      enrollment_reason_qle: '我经历了符合条件的生活事件。',
      enrollment_reason_info_current_year: '我需要了解今年的福利信息。',
      enrollment_reason_info_next_year: '我需要了解明年的福利信息。',
      tooltips: {
        name: {
          text: '符合资格的生活事件是指重大的生活变化,允许您在常规登记期之外对您的福利进行调整,包括结婚或离婚、家庭新增子女或居住地变更。',
          title: '登记',
          underline: '登记',
        },
      },
      enrollment_reason_explainer_active:
        '要查看当前计划年度的福利，请点击"我是新员工"、"我有符合条件的生活事件"或"我需要了解今年的福利信息"。',
      enrollment_reason_explainer_upcoming: '要查看即将到来的计划年度福利,请点击"我需要了解明年的福利信息"。',
      enrollment_reason_explainer_open_enrollment: '要查看即将到来的计划年度福利,请点击"我来参加开放注册"。',
      enrollment_reason_explainer_choose_any: '出于审核目的,您可以点击下方任意选项。',
      enrollment_plan_label_active: '适用于{plan_year}计划,有效期至{end_date}',
      enrollment_plan_label_upcoming: '适用于{plan_year}计划,生效日期{start_date}至{end_date}',
    },
    pregnancy_illustration:
      'https://picwellapppublicdata.s3.amazonaws.com/contentful/profileimages/walking-baby.svg',
    member: {
      contentful_name: '[DEFAULT] Member Card',
      name: '家居用品',
      policyholder_card_header: '您',
      spouse_card_header: '配偶',
      domestic_partner_card_header: '配偶/伴侣',
      dependent_card_header: '受抚养人',
      household_claims: {
        contentful_name: '[Profile] [Member Card] Household Claims',
        header:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '您目前已自付至少',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '**{oopSpent}**',
                  marks: [
                    {
                      type: 'code',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: ' ',
                  marks: [],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '费用',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value:
                    ',这是根据您当前计划提交的理赔计算得出的。请务必在下方的医疗保健使用部分中考虑这些护理费用。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'BellRinging',
        url_button_text:
          'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      },
      household_claims_no_usage: {
        contentful_name: '[Profile] [Member Card] Household Claims - No Usage',
        header:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value: '根据您当前计划提交的理赔申请,您目前尚未自付任何费用',
                  marks: [
                    {
                      type: 'bold',
                    },
                  ],
                  data: {},
                },
                {
                  nodeType: 'text',
                  value: '。请务必在下方的医疗保健使用部分中考虑这一点。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        color: 'blue',
        icon: 'BellRinging',
        url_button_text:
          'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      },
      household_claims_loading_message: '正在加载您的消费详情...',
      household_claims_error_message: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '我们无法检索您的索赔信息。',
                marks: [],
                data: {},
              },
              {
                nodeType: 'text',
                value: '{x}',
                marks: [
                  {
                    type: 'code',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      age_label: '年龄',
      spouse_label: '配偶',
      domestic_partner_label: '同居伴侣',
      domestic_partner_question_label: '这是您的配偶或同居伴侣吗?',
      tobacco_label: '使用烟草',
      tobacco_header: '{x}使用任何烟草产品吗?',
      prescription_header: '{x}是否定期服用任何处方药?',
      drug_search_label: '添加处方',
      no_prescription_button: '{x}不服用任何处方药',
      utilization_header: '在过去12个月中,{x}是否看过初级保健医生(不包括常规体检)、专科医生或住过院?',
      no_utilization_button: '{x}没有任何就诊/入院记录',
      drug_search_placeholder: '搜索以添加处方',
      utilization_instructions: '添加过去12个月的医疗保健使用情况。',
      pcp_exclusions: '不包括常规体检。',
      hospital_exclusions: '不包括分娩住院。',
      coverage_text: {
        error: '无效的{x}',
        myself: '您只为自己投保',
        incomplete: '{x}缺少必填字段',
        meAndChild: '您只为自己和一名子女投保',
        meAndOthers: '为您自己和{x}名家庭成员投保。',
        meAndSpouse: '为您自己和您的配偶投保',
        meAndOthersMobile: '我为{x}人投保',
        meAndDomesticPartner: '为您自己和您的伴侣投保',
        meAndSpouseDomesticPartner: '为您自己和您的配偶/伴侣投保',
      },
      tooltips: {
        sex: {
          text: '出生时指定的性别不一定与个人的性别认同相同。然而,ALEX的计算参考了需要此信息的保险理赔。结合您的年龄,您对此问题的回答有助于通过考虑与身体解剖结构相关的重要服务来更准确地估算您的费用。',
          title: '出生时指定的性别',
          underline: '出生时指定的性别',
        },
        name: {
          text: 'ALEX使用此信息来估算您可能需要的护理量,并根据您所承保的人员计算保费。',
          title: '家庭',
          underline: '家庭',
        },
        tobacco: {
          text: '您可能需要为某些符合条件的福利支付烟草附加费。',
          title: '使用烟草',
          underline: '使用烟草',
        },
        pcp_visits: {
          text: '在过去12个月中,{x}去看{y}初级保健医生多少次(不包括{y}常规体检)?',
          title: '初级保健医生就诊次数',
          underline: '初级保健医生就诊次数',
        },
        utilization: {
          text: '虽然医疗需求通常每年都有所不同,但了解过去的医疗保健使用情况有助于ALEX预测费用并提供更个性化的建议。',
          title: '使用情况',
          underline: '使用情况',
        },
        prescriptions: {
          text: '此信息用于预测您的费用、考虑潜在风险并提供个性化建议。您的所有数据都将保密。',
          title: '处方药',
          underline: '处方药',
        },
        hospital_visits: {
          text: '在过去12个月中,{x}住院多少天(不包括因分娩而住院)?',
          title: '住院天数',
          underline: '住院天数',
        },
        domestic_partner: {
          text: '您的婚姻状况可能会影响某些资格和税收优惠详情。',
          title: '婚姻和同居伴侣关系',
          underline: '婚姻和同居伴侣关系',
        },
        specialist_visits: {
          text: '在过去12个月中,{x}去看专科医生(例如过敏科医生、皮肤科医生)多少次?',
          title: '专科医生就诊次数',
          underline: '专科医生就诊次数',
        },
        dependent_age_info: {
          text: '受抚养人通常可以承保至26岁,但在某些情况下,他们可能有资格延长承保时间。如果您不确定受抚养人的资格,请查看您的计划文件。',
          title: '受抚养人年龄信息',
          underline: '受抚养人年龄信息',
        },
        mental_health_visits: {
          text: '在过去12个月中,{x}去看心理健康服务提供者(例如治疗师、精神科医生或心理学家)多少次?',
          title: '心理健康就诊次数',
          underline: '心理健康就诊次数',
        },
      },
      add_policyholder_button: '添加自己',
      add_spouse_button: '添加配偶',
      add_spouse_or_domestic_partner_button: '添加配偶/伴侣',
      add_dependent_button: '添加受抚养人',
      accessibility: {
        pcp_counter: '初级保健医生就诊次数',
        remove_spouse: '移除配偶',
        add_drug_alert: '已添加 {x}',
        remove_dependent: '移除受抚养人',
        inpatient_counter: '住院天数',
        remove_drug_alert: '已移除 {x}',
        remove_drug_button: '移除 {x}',
        specialist_counter: '专科医生就诊次数',
        remove_spouse_alert: '配偶已移除',
        remove_dependent_alert: '受抚养人已移除',
        drug_search_results_alert: '{x} 条结果',
      },
      button_options: {
        no: '否',
        yes: '是',
        male: '男',
        female: '女',
        prefer_not_to_say: '不愿透露',
      },
      add_member_disclaimer: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '输入您希望在任何福利计划中覆盖的所有家庭成员。稍后您将有机会选择在每个计划中覆盖哪些人。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      text_note: {
        contentful_name: '[DEFAULT] Text Note',
        short_text: {
          data: {},
          content: [
            {
              data: {},
              content: [
                {
                  data: {},
                  marks: [],
                  value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                  nodeType: 'text',
                },
              ],
              nodeType: 'paragraph',
            },
          ],
          nodeType: 'document',
        },
        long_text: {
          nodeType: 'document',
          data: {},
          content: [
            {
              nodeType: 'paragraph',
              content: [
                {
                  nodeType: 'text',
                  value:
                    '您提供的内容为空,没有需要翻译的文本。请提供需要从英语(美国)翻译成简体中文(中国)的具体内容。',
                  marks: [],
                  data: {},
                },
              ],
              data: {},
            },
          ],
        },
        button_text: '阅读更多',
      },
      planned_procedures: {
        contentful_name: '[DEFAULT] Profile Section / Member / Planned Procedures',
        header_policyholder: '在未来12个月内,您是否有任何已知的医疗需求?',
        header_household_member: '在未来12个月内,他们是否有任何已知的医疗需求?',
        instructions_policyholder: '添加您预计未来12个月的医疗保健需求。',
        instructions_household_member: '添加他们预计未来12个月的医疗保健需求。',
        no_procedures_button_policyholder: '我在未来一年没有任何已知的需求。',
        no_procedures_button_household_member: '他们在未来一年没有任何已知的需求。',
        tooltips: {
          header_policyholder: {
            text: '此信息帮助ALEX计算您预计在未来一年需要的任何医疗护理费用,并提供更个性化的建议。',
            title: '计划手术',
            underline: '计划手术',
          },
          inpatient_procedures: {
            text: '住院手术需要在手术后至少在医院住院一晚。',
            title: '住院手术',
            underline: '住院手术',
          },
          outpatient_procedures: {
            text: '门诊手术是在一天内完成的手术,无需在医院过夜。',
            title: '门诊手术',
            underline: '门诊手术',
          },
          header_household_member: {
            text: '此信息帮助ALEX计算您的家人预计在未来一年需要的任何医疗护理费用,并提供更个性化的建议。',
            title: '计划手术',
            underline: '计划手术',
          },
          mental_health_visits_policyholder: {
            text: '您预计在未来12个月内会去看心理健康服务提供者(例如治疗师、精神科医生或心理学家)多少次?',
            title: '心理健康就诊',
            underline: '心理健康就诊',
          },
          routine_therapy_visits_policyholder: {
            text: '您预计在未来12个月内会进行多少次物理治疗?包括任何脊椎按摩治疗。',
            title: '物理治疗(包括脊椎按摩)',
            underline: '物理治疗(包括脊椎按摩)',
          },
          mental_health_visits_household_member: {
            text: '他们预计在未来12个月内会去看心理健康服务提供者(例如治疗师、精神科医生或心理学家)多少次?',
            title: '心理健康就诊',
            underline: '心理健康就诊',
          },
          routine_therapy_visits_household_member: {
            text: '他们预计在未来12个月内会进行多少次物理治疗?包括任何脊椎按摩治疗。',
            title: '物理治疗(包括脊椎按摩)',
            underline: '物理治疗(包括脊椎按摩)',
          },
        },
      },
      pcp_visit_labels: {
        contentful_name: '[default] PCP Visit Labels',
        zero_visits_label: '0',
        one_visit_label: '1',
        two_to_four_visits_label: '2 - 4',
        five_or_more_visits_label: '5+',
      },
      specialist_visit_labels: {
        contentful_name: '[default] Specialist Visit Labels',
        zero_visits_label: '0',
        one_to_six_visits_label: '1 - 6',
        seven_to_twelve_visits_label: '7 - 12',
        thirteen_or_more_visits_label: '13+',
      },
      inpatient_labels: {
        contentful_name: '[default] Inpatient Day Labels',
        zero_days_label: '0',
        one_to_two_days_label: '1 - 2',
        three_or_more_days_label: '3+',
      },
      pronoun_map: {
        i: '我',
        you: '你',
        they: '他们',
      },
    },
    pregnancy_description:
      '怀孕费用高昂。我们会将这一信息纳入考量,以便明年为您的家庭医疗需求提供更准确的建议。',
    location: {
      contentful_name: '[DEFAULT] Location Card',
      name: '住所',
      header: '你住在哪里?',
      zipcode_label: '邮政编码',
      zipcode_placeholder: '11111',
      state_label: '州',
      state_placeholder: '请选择...',
      tooltips: {
        name: {
          text: '您的居住地有助于预测您的自付费用,并可能影响您有资格申请的计划。',
          title: '居住地',
          underline: '居住地',
        },
      },
    },
    pregnancy: {
      contentful_name: '[DEFAULT] Pregnancy Card',
      name: '怀孕',
      header: '您的家庭是否计划在未来一年内怀孕?',
      button_options: {
        no: '否',
        yes: '是',
      },
      tooltips: {
        name: {
          text: '怀孕费用高昂。ALEX 会将此因素纳入考量,为您家庭明年的医疗需求提供更准确的建议。',
          title: '怀孕',
          underline: '怀孕',
        },
      },
    },
    audio_configuration: {
      audio_configuration_title: '[default] Audio Configuration',
      profile_start_audio: {
        audio_moment_title: '[default] Profile Start Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/Jqr4q8XscXdexdXFkUoN6/302bff359b17a09c573176d7d3eb9767/Profile_UpdatedSFX_01.mp3',
        audio_file_url_for_mobile:
          'https://assets.ctfassets.net/z0ugtcgrmslx/4lBaycyQjv2Nb12KAjR41V/65a1ca6ff2f911bbf0be75bfdac6070a/User_Profile_-_Opening_VO.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2Ad1EJLbSeW5RcKTeh3M7/cacdbf4d8cb16b70d00df5783f50f2f8/User_Profile_-_Opening_VO___SFX.vtt',
      },
      profile_complete_audio: {
        audio_moment_title: '[default] Profile Complete Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/7BfGH1uItS51wVz4qpsWMk/24cb1411a437cc7fb0b7df4d276abb02/Profile_UpdatedSFX_04.mp3',
        audio_file_url_for_mobile:
          'https://assets.ctfassets.net/z0ugtcgrmslx/4zlEev7MEy6sTl92ceg0lD/245d58c50115d79d53af6b9eb95d3735/5_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1e5bu2EnPeAhNUw6lZvwfG/13b1fd3f96d10b234ad479ed19061695/5_P-desktop.vtt',
        vtt_transcript_file_url_for_mobile:
          'https://assets.ctfassets.net/z0ugtcgrmslx/7ymLBho52pAiAtnGBe4FRg/7f85bb0a1790f4d4635cac4610aa9f27/5_P.vtt',
      },
      residence_section_audio: {
        audio_moment_title: '[default] Okay Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5ubsEhtY46OqCz4E3mjSHP/71f55993684153601db745ec3d8fdb46/4A-2_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1PhYAhbftZcP4bympZaJAX/405eb63a5a33bd2122a3f7c4dc985fdd/4A-2_P.vtt',
      },
      household_section_audio: {
        audio_moment_title: '[default] Great Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5Ntn8bHh08e2xG9dKmY1tO/a477b620b08f238b32ffce4bdf05121b/Profile_UpdatedSFX_02.mp3',
        audio_file_url_for_mobile:
          'https://assets.ctfassets.net/z0ugtcgrmslx/4T5iHslDdwQU7bcVjgcKWL/a65977308ecb225d37fbb0e0f79089c1/4B-3_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/4Gn68YzPTeWH7ssx0PPc31/ce5e8524a8ca12a480064232741285b4/4B-3_P.vtt',
      },
      income_section_audio: {
        audio_moment_title: '[default] Got it Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/7dt62Rnun76jR8DldfpwYl/9d5ebd03eaa68d64b882d761d2358b33/4C-1_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/Et5hvQsKZThUUSsNqaMlW/e9dbe10b37e75824e5c66e154985f0b1/4C-1_P.vtt',
      },
      risk_aversion_section_audio: {
        audio_moment_title: '[default] Uh huh Audio',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2sdG8L8uWBU6ep79QbbJQV/0b0295e09f04d83639b9f2bf7e122091/Profile_UpdatedSFX_03.mp3',
        audio_file_url_for_mobile:
          'https://assets.ctfassets.net/z0ugtcgrmslx/28MLe6mjVDUKedWdoJcQQn/ae6b335e31560acf19c35ee8f0956d94/4F_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2RZJt206MUHdKqeshAkRH7/7389e79b5041cd64a42f23639b45706a/4F_P.vtt',
      },
      enrollment_section_audio_tooltip: {
        audio_moment_title: '[default] Enrollment Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2BblItZtneuMgxfPqqJwUI/1c2abfd0d2ca037fe41f8e293b86d02f/1_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6ICowR27rFf9qbBGx95x4I/6c4b54aa8d1854a8a3273dc3b8b75b58/1_P.vtt',
      },
      residence_section_audio_tooltip: {
        audio_moment_title: '[default] Residence Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/0Ro5ywJkcvDWDUax0LmEI/7d3ed45e2c993762c7c048faff7d54c1/2_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2NGHgs8WeElAnmoDrr4JWa/13d53532d6b9ab3104488580f7abf09c/2_P.vtt',
      },
      household_section_audio_tooltip: {
        audio_moment_title: '[default] Household Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/mCQ7MTFIBg7MQWNuYoVry/0d6ceca762aa84403813da55d61b5ba8/3_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/fN7dLtQooVdHjzbc38CnS/e83b2da4f4fed2e759aa1a3b3a96b3df/3_P.vtt',
      },
      sex_at_birth_audio_tooltip: {
        audio_moment_title: '[default] Sex at Birth Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/mwygCOipDaUnLBC2JODXG/244ca3cc304234f5e95b8b33ed0058d5/4_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1Hvgi204HgPg8ZpZ3zSgyi/51794bd29d4d939923eb447c0447877f/4_P.vtt',
      },
      prescription_drugs_audio_tooltip: {
        audio_moment_title: '[default] Prescription Drugs Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6xH8KSDAXpAZt3FkxExZjs/e69468ba2ac14c684c2ace078828cf00/1_P.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6XZnO2BXe5Mu5S6nSPQ6wk/89a486958bddacfd2db2c4192bf6cf75/1_P.vtt',
      },
      utilization_section_audio_tooltip: {
        audio_moment_title: '[default] Medical Needs (Utilization) Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/TLrjnjZnmmUePMMbGUlMu/a2563ee76762703f09c7df2a4185cde2/6_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2Ilgkf4s6Ksfcx1P7TUtKj/69c881e75b0ff1e9f48393371040f580/6_P.vtt',
      },
      pcp_audio_tooltip: {
        audio_moment_title: '[default] PCP Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/4OZJ1fD9poT7E2cmEga1Eu/d04d2ac40431dbadfc4dcdba9b530ee9/7_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5LIrthpyvFYjn2WWVprlSr/47b404fd09301bd28c2c965dad0a19a5/7_P.vtt',
      },
      specialist_audio_tooltip: {
        audio_moment_title: '[default] Specialist Visits Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6MHGBwLPj5M5ynLWO8Strn/172058c02299eb6da418216e15fa7319/8_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5yEUGq2WDRsmZFWgAb7gD1/e8ee8cc75e6be61006067ebf131cc6d9/8_P.vtt',
      },
      hospital_stays_audio_tooltip: {
        audio_moment_title: '[default] Hospital Stays Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/237PHQVrhT73EIK9cC6PaO/68c494c85f7622af55bc4d42a226945a/9_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6MYr7Yj86oOg1KZuu3qJRm/ac24da011fb140dfed31d6476101c53c/9_P.vtt',
      },
      mental_health_audio_tooltip: {
        audio_moment_title: '[default] Mental Health Visits Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/10S3ib09YLVgzRb4D556tQ/e2fabae0013c966f40e509a5b8dea6be/10_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/MLia6GD9QLccUcXKHSzCK/41c5c8a814e5724e8af68fda40536388/10_P.vtt',
      },
      pregnancy_section_audio_tooltip: {
        audio_moment_title: '[default] Pregnancy Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3PaMaYbydRWAITl9TUZrAF/a7f3f89917a5035ae5162a9a1080ffba/11_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/29fCbwNLz9jyRPcQwuvPEp/39767855efb23b7d4a7808dc72b4ca0b/11_P.vtt',
      },
      income_section_audio_tooltip: {
        audio_moment_title: '[default] Income Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2wv8gTFtXvJibR7U3V2Qow/328f0b49119b079181f5b5d068f78290/12_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3f62S6BIl8kQm1oU8HfYvS/b24036f7ed24c5fcdf33094f7170cfdb/12_P.vtt',
      },
      risk_section_audio_tooltip: {
        audio_moment_title: '[default] Risk Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5TVZCRNXvzQcjxROHBvHmm/b3bbac623c00fd46cbc56649fa54ed62/13_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3YVFic5dAG33An3qJeeST8/0592347437311a879c431a27e8f73a13/13_P.vtt',
      },
      affordability_section_audio_tooltip: {
        audio_moment_title: '[default] Affordability (Capacity to Pay) Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3PWJhoDhqNJMSbKeWKLinJ/fdcf882003a421e5a5da601a68a774e6/14_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1n0SLFkwrHGaRSImCqsfnQ/28c1dedb95ccf3e5ef874d93ae561a59/14_P.vtt',
      },
      planned_procedures_question_audio_tooltip: {
        audio_moment_title: '[Default] Planned Procedures Question',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3xbHI4BwRckidkg5OyxsLj/9ef58638020c9ccec4e35ebd0465d31a/Polished_Operations.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2GiXdymvL5JIJrw7panh9v/66e8e3fa500288f1d31f822061b8afd0/1_P.vtt',
      },
      planned_procedures_inpatient_audio_tooltip: {
        audio_moment_title: '[Default] Planned Procedures Inpatient Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2ZEFMDun7NlhITOYc4w2sf/be740490eb1ccd24649905660ae342ce/Polished_Operations__1_.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/3NGJVbGjPyUBU3SlEwUf9z/7f1715cf3bd035af2a546efd64ec874d/2_P.vtt',
      },
      planned_procedures_outpatient_audio_tooltip: {
        audio_moment_title: '[Default] Planned Procedures Outpatient Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/7JKIjDVMCOmqLzo86nqbdt/4f16f1f7d2061a087f5a286f663f22a9/Polished_Operations__2_.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/jN5EccMBkI8dYx0w5iB5o/0e221efcde8c4a75cf589e2cf7292d7f/3_P.vtt',
      },
      planned_procedures_routine_therapy_audio_tooltip: {
        audio_moment_title: '[Default] Planned Procedures Therapy Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5Umm9xPNlbxPX7oGyxak30/e71b2d08f41e742304c6d450e106c9b5/Polished_Operations__3_.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5g2VFqk8FVx6tlwEMyvWaF/444a2aaa0a7f8e6ac5b23be094b9997c/4_P.vtt',
      },
      planned_procedures_mental_health_audio_tooltip: {
        audio_moment_title: '[default] Mental Health Visits Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/10S3ib09YLVgzRb4D556tQ/e2fabae0013c966f40e509a5b8dea6be/10_P.wav',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/MLia6GD9QLccUcXKHSzCK/41c5c8a814e5724e8af68fda40536388/10_P.vtt',
      },
      claims_section_audio_tooltip: {
        audio_moment_title: '[default] Claims Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6HeSU9cQbbMOCR8bSx5hqm/c102ac683194f29d55266203da031899/1_P.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1XpbRmFE3YjDK5cCHj7fTa/af32c9198675880ae854151c3a3db400/1_P.vtt',
      },
      claims_section_member_id_audio_tooltip: {
        audio_moment_title: '[default] Claims Section Member Id Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6GDKVk3k9pR8Yr9DFJ5byV/34fc257b44d2547ed5fa6c1b9a5d55f8/2_P.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/77O4LowlAq95VfRtBgdHMI/f3cc6e51c7bf95aeb6ef0ce532aab9cc/2_P.vtt',
      },
      medicare_section_audio_tooltip: {
        audio_moment_title: '[default] Medicare Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/37b4JcEVWPq8yvxQPnrBiY/fbba5f27e4a294e2db7c6f81efc81975/1_P.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/5qvGyxV6kOpYRHynLRtam6/b54aa209a4abd893bdff694443168966/1_P.vtt',
      },
      claims_feedback_household_and_risk_section: {
        audio_moment_title: '[default] Claims Household And Risk Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1bviQqwWXtEzKbgMhUukpG/ae0e6941cf4e214ee438b8eda59dfce0/1_D.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/7qX0VgL0tQhrqm04XbaTz0/08a7ef9da545a08504769173a99106fb/1_D.vtt',
      },
      hsa_funds_section_audio_tooltip: {
        audio_moment_title: '[default] HsaFunds Section Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1jSdjkWvOJd1mRc8lxnJed/eb7367e644b21b4dbe5fe22f23df5f7d/1_P.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2l4WNO7rj1nOdYyLbF0vny/a6e847fb0edc8d6e64c54263fe898f2d/1_P.vtt',
      },
      fewer_in_network_doctors_audio_tooltip: {
        audio_moment_title: '[default] Fewer in-network doctors Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2tggT0gzhBTrxYsYgupCdk/0e9d47e6f3ca11c8d03ef0a8d29ee3c0/1_D.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1i3KvKvPcL84HJWsYKTkHu/d388b4088fa8e8e972f4d0283f903de7/1_D.vtt',
      },
      national_coverage_need_audio_tooltip: {
        audio_moment_title: '[default] National Coverage Need Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/p71BJVfZFlDW4EPAIHdeS/8242918bf7f0dac9500a462cead944e1/2_D.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/6cXpIiA6tsW7z1BSnnFvuy/d73eb142a4eb7a6d0e151dd43ae56991/2_D.vtt',
      },
      referral_requirement_audio_tooltip: {
        audio_moment_title: '[default] Referral Requirement Audio Tooltip',
        audio_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/1XCgQNWgtzqkidOh3CrIEX/26e45fa2b20dc488a6a902bc377cc7b2/3_D.mp3',
        vtt_transcript_file_url:
          'https://assets.ctfassets.net/z0ugtcgrmslx/2hxvYzzGjGBhQKWIPUZTWn/5ed133869c85315d7832713f347cc211/3_D.vtt',
      },
    },
    member_headings: {
      others: '您的计划将覆盖哪些人?',
      single: '您的计划将覆盖哪些人?',
    },
    capacity_heading: '如果您需要接受意外的医疗护理,您能承担的最大账单金额是多少?',
    income_description: '您的部分福利享有税收优惠。我们将根据您的收入计算这些税收优惠的价值。',
    error_text: {
      invalidCarrierInput: '请选择保险公司。',
      invalidZipCodeInput: '不正确',
      invalidDateOfBirthInput: '请输入有效的出生日期。',
      invalidEligibilityInput: '"{x}"不是此问题的有效输入。',
    },
    util_questions: {
      pcpVisit: '在过去12个月中,您{x}去看初级保健医生(不包括常规体检)多少次?',
      specialVisit: '在过去12个月中,您{x}去看专科医生多少次?',
      hospitalVisit: '在过去12个月中,您{x}住院(不包括因分娩住院)多少天?',
      indvAndFamily: '或您的家人',
    },
    incentives: {
      contentful_name: '[DEFAULT] Incentives Card',
      name: '激励/附加费',
      tooltips: {
        name: {
          text: '参与这些计划可能会影响您的保费或雇主为帮助支付您的医疗费用而提供的缴费金额。',
          title: '激励措施/附加费',
          underline: '激励措施/附加费',
        },
      },
      success_custom_messages: [
        {
          contentful_name: '[DEFAULT] Incentives Success Message',
          header:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '根据您的回答,以下是一些可能影响您费用的额外项目。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'blue',
          icon: 'Info',
          url_button_text:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
        },
        {
          contentful_name: '[DEFAULT] Incentives Profile Change Notice',
          header:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '更改上述个人资料答案可能会导致这些问题重置。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'yellow',
          icon: 'Info',
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
        },
      ],
      empty_custom_messages: [
        {
          contentful_name: '[DEFAULT] No Incentives Eligible',
          header:
            'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
          text: {
            nodeType: 'document',
            data: {},
            content: [
              {
                nodeType: 'paragraph',
                content: [
                  {
                    nodeType: 'text',
                    value: '根据您对上述个人资料问题的回答,您目前似乎不符合任何激励措施的资格。',
                    marks: [],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
          },
          color: 'yellow',
          icon: 'Info',
          url_button_text:
            'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated, and I will immediately generate the translation for you.',
        },
      ],
    },
  },
};
